import styled from "styled-components"
import { device } from "breakpoints"

import { Teaser } from "../Teaser"
import { Title, Excerpt, InfoContainer, ImageContainer } from "../Teaser/style"
import AvenueLink from "components/AvenueLink"

export const CTAButton = styled(AvenueLink)`
  display: flex;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  border: 2px solid #f17071;
  border-radius: 24.5px;
  align-items: center;
  text-transform: uppercase;
  /* height: 42px; */
  line-height: 1.1;
  padding: 10px 25px;
  transition: 150ms;

  @media ${device.tablet} {
    font-size: 16px;
    /* height: 48px; */
    padding: 10px 30px;
  }
`
export const CustomCTATeaser = styled(Teaser)`
  margin: 30px 0;
  cursor: pointer;

  @media ${device.tablet} {
    flex-direction: row-reverse;
    align-items: stretch;
  }
  @media ${device.desktop} {
    margin: 60px 0;
  }

  :hover {
    ${Title} {
      color: #fff;
    }
    ${CTAButton} {
      background-color: #f17071;
    }
  }

  ${Title} {
    font-weight: 600;
    font-size: 20px;
    color: #ffffff;
    margin-bottom: 16px;
    line-height: 110%;

    @media ${device.tablet} {
      font-size: 24px;
      letter-spacing: -0.25px;
      line-height: 24px;
      margin-bottom: 27px;
    }
  }
  ${Excerpt} {
    font-size: 16px !important;
    color: #ffffff !important;
    margin-bottom: 25px !important;
    line-height: 150% !important;
    @media ${device.tablet} {
      font-size: 18px !important;
      margin-bottom: 28px !important;
    }
  }

  ${ImageContainer} {
    margin-bottom: 0;
    padding-top: 79.7%;
    @media ${device.tablet} {
      padding-top: 48.05%;
      width: 50%;
    }
  }

  ${InfoContainer} {
    background: #2a3449;
    padding: 30px 30px 35px 30px;
    @media ${device.tablet} {
      width: 50%;
      align-self: normal;
      height: auto;
      justify-content: center;
      padding: 45px 39px;
    }

    @media ${device.desktop} {
      padding: 45px 50px 60px 50px;
    }
  }
`
